class LocalStorageClass {
  private storageAvailable = false;

  constructor() {
    try {
      // eslint-disable-next-line no-restricted-syntax
      localStorage.setItem('availabilityTest', 'test');
      // eslint-disable-next-line no-restricted-syntax
      if (localStorage.getItem('availabilityTest') === 'test') {
        this.storageAvailable = true;
      }
      // eslint-disable-next-line no-restricted-syntax
      localStorage.removeItem('availabilityTest');
    } catch (error) {
      this.handleLocalStorageError(error as Error, { key: 'availabilityTest' });
    }
  }

  isAvailable(): boolean {
    return this.storageAvailable;
  }

  remove(key: string): void {
    if (!this.storageAvailable) return;
    try {
      // eslint-disable-next-line no-restricted-syntax
      localStorage.removeItem(key);
    } catch (error) {
      this.handleLocalStorageError(error as Error, { key });
    }
  }

  set(key: string, payload: string | number): void {
    if (!this.storageAvailable) return;
    try {
      // eslint-disable-next-line no-restricted-syntax
      localStorage.setItem(key, payload.toString());
    } catch (error) {
      this.handleLocalStorageError(error as Error, { key, payload: payload.toString() });
    }
  }

  setJson(key: string, payload: Record<string, string>): void {
    try {
      this.set(key, JSON.stringify(payload));
    } catch (error) {
      this.handleLocalStorageError(error as Error, { key, payload });
    }
  }

  get(key: string): string | null | undefined {
    if (!this.storageAvailable) return null;
    try {
      // eslint-disable-next-line no-restricted-syntax
      return localStorage.getItem(key);
    } catch (error) {
      this.handleLocalStorageError(error as Error, { key });
    }
  }

  getJson<Payload = Record<string, string>>(key: string): Payload | null | undefined {
    if (!this.storageAvailable) return null;
    try {
      // eslint-disable-next-line no-restricted-syntax
      const value = localStorage.getItem(key);
      if (value) {
        return JSON.parse(value);
      }
    } catch (error) {
      this.handleLocalStorageError(error as Error, { key });
    }
  }

  private readonly handleLocalStorageError = (
    error: Error,
    options: {
      key: string;
      payload?: string | Record<string, string>;
    }
  ): void => {
    console.log(error, options);
  };
}

export const LocalStorage = new LocalStorageClass();
